import { render, staticRenderFns } from "./inplace.vue?vue&type=template&id=98c060c0&scoped=true"
import script from "./inplace.vue?vue&type=script&lang=js"
export * from "./inplace.vue?vue&type=script&lang=js"
import style0 from "./inplace.vue?vue&type=style&index=0&id=98c060c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98c060c0",
  null
  
)

export default component.exports